module.exports = __webpack_public_path__ + "img/banner_4.67b36a61.jpg";